module.exports = __webpack_public_path__ + "static/img/icon_wx.59b9e4db.png";